(function () {
  const COLOR_SYNC_EVENT = 'card-swatch:color-selected';

  function normalizeColor(value) {
    return (value || '').trim().toLowerCase();
  }

  function applySwatchToCard(host, color) {
    const swatches = host.querySelectorAll('[data-card-swatch]');
    let matched = null;
    swatches.forEach((btn) => {
      const isMatch = normalizeColor(btn.dataset.color) === color;
      btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      if (isMatch) matched = btn;
    });

    if (!matched) return false;

    const img = host.querySelector('[data-card-swatch-image]');
    const hasImage = Boolean(matched.dataset.imageSrc);

    // A colour with no photo of its own just keeps the one already showing
    // — quieter than announcing the gap on the card.
    if (img && hasImage) {
      const src = matched.dataset.imageSrc;
      const srcset = matched.dataset.imageSrcset;
      const alt = matched.dataset.imageAlt;
      const w = matched.dataset.imageWidth;
      const h = matched.dataset.imageHeight;

      const isNewImage = src && img.getAttribute('src') !== src;

      if (isNewImage) {
        host.classList.add('is-swatch-loading');
        const clear = () => host.classList.remove('is-swatch-loading');
        const preload = new Image();
        preload.onload = () => {
          if (srcset) img.setAttribute('srcset', srcset);
          img.setAttribute('src', src);
          if (alt) img.setAttribute('alt', alt);
          if (w) img.setAttribute('width', w);
          if (h) img.setAttribute('height', h);
          requestAnimationFrame(clear);
        };
        preload.onerror = clear;
        preload.src = src;
      } else if (alt) {
        img.setAttribute('alt', alt);
      }
    }

    const cardLinks = host.querySelectorAll('a.full-unstyled-link');
    const variantUrl = matched.dataset.variantUrl;
    if (variantUrl) {
      cardLinks.forEach((a) => {
        a.setAttribute('href', variantUrl);
      });
    }

    return true;
  }

  function onSwatchClick(event) {
    const btn = event.target.closest('[data-card-swatch]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const host = btn.closest('[data-card-swatches-host]');
    if (!host) return;
    const color = normalizeColor(btn.dataset.color);
    if (!color) return;

    applySwatchToCard(host, color);

    document.dispatchEvent(
      new CustomEvent(COLOR_SYNC_EVENT, {
        detail: { color, sourceProductId: host.dataset.productId },
      })
    );
  }

  function onColorSync(event) {
    const { color, sourceProductId } = event.detail || {};
    if (!color) return;
    const hosts = document.querySelectorAll('[data-card-swatches-host]');
    hosts.forEach((host) => {
      if (host.dataset.productId === sourceProductId) return;
      applySwatchToCard(host, color);
    });
  }

  document.addEventListener('click', onSwatchClick);
  document.addEventListener(COLOR_SYNC_EVENT, onColorSync);
})();
